import { CheckoutSteps } from '../constants';
export const getSkeletonHeight = (step, isMobileView) => {
    if (step === CheckoutSteps.SHIPPING_DETAILS) {
        return isMobileView ? 3200 : 2460;
    }
    if (step === CheckoutSteps.ORDER_REVIEW) {
        return isMobileView ? 780 : 990;
    }
    return 380;
};
